import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_screen--not-m" }
const _hoisted_2 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_product_breadcrumb = _resolveComponent("product-breadcrumb")
  const _component_product_details = _resolveComponent("product-details")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.model)
      ? (_openBlock(), _createBlock(_component_product_details, _normalizeProps(_mergeProps({ key: 0 }, _ctx.model)), _createSlots({ _: 2 /* DYNAMIC */ }, [
          (!!_ctx.model)
            ? {
                name: "top",
                fn: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("a", {
                      href: _ctx.model.projectUrl,
                      class: "gfu-link gfu-link--block gfu-link--nofx _tc--accent _mb-6"
                    }, [
                      _createVNode(_component_base_icon, { name: "chevron-left" }),
                      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "_ml-1" }, "go back to the project page", -1 /* CACHED */))
                    ], 8 /* PROPS */, _hoisted_2)
                  ]),
                  _createVNode(_component_product_breadcrumb, _mergeProps($options.breadcrumbsModel, { class: "_screen--none _screen--m _mb-6" }), null, 16 /* FULL_PROPS */)
                ]),
                key: "0"
              }
            : undefined
        ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
  ]))
}